package co.uk.sacursoftware.ssinventory.ui

import androidx.compose.foundation.layout.*
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import ssinventory.shared.generated.resources.Res
import ssinventory.shared.generated.resources.asset_6
import androidx.compose.foundation.Image

@Composable
fun BrandLoadingSpinner(
    modifier: Modifier = Modifier
) {
    BoxWithConstraints(
        modifier = modifier,
        contentAlignment = Alignment.Center
    ) {
        val logoWidth = (maxWidth * 0.30f).coerceAtLeast(48.dp)
        val spinnerSize = logoWidth + 48.dp
        
        val logoResource = Res.drawable.asset_6

        Box(
            modifier = Modifier.size(spinnerSize),
            contentAlignment = Alignment.Center
        ) {
            CircularProgressIndicator(
                modifier = Modifier.fillMaxSize(),
                color = Color(0xFFE52321),
                strokeWidth = 4.dp
            )
            Image(
                painter = painterResource(logoResource),
                contentDescription = "Loading...",
                modifier = Modifier.width(logoWidth),
                contentScale = ContentScale.Fit
            )
        }
    }
}
